import React, { Component } from 'react';
import { Form, FormGroup, FormControl, ControlLabel, Col, Button, Radio, Glyphicon, PanelGroup, Panel } from 'react-bootstrap';
import Api from '../../../../../Global/Modules/Api'



class VerklaringenToevoegen extends Component {
    constructor() {
        super();
        this.handleChange = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            data: {
            },
            errors: {},
            references: []
        }
    }
    handleChange(event) {
        const target = event.target
        const name = target.name
        const value = target.value
        this.setState({ data: { ...this.state.data, [name]: value } })
    }

    // Function that will be executed when the submit button is pressed
    handleSubmit(event) {
        event.preventDefault()

        var formData = new FormData()

        const file = this.fileInput.files[0]
        formData.append('file', file === undefined ? null : file)

        Api.PostApiWithFile("api/members/" + this.props.id + "/saveVerklaringen", formData, this.props.history)
            .then(response => {
                if (response !== undefined) {
                    Api.print('Response')
                    Api.print(response)
                    var errorsResponse = true
                    Object.keys(response).forEach(e => {
                        if (typeof response[e] !== "object") {
                            errorsResponse = false
                            return
                        }
                    })

                    if (errorsResponse)
                        this.setState({ errors: response });
                    else {
                        alert("Verklaringen added")
                        this.props.handle()
                        this.setState({ errors: {} })
                    }
                }

                else {
                    alert("Verklaringen added");
                }
            })
    }
    render() {
        let errors = this.state.errors
        return (
            <div>
                <PanelGroup accordion id="KennisToevoegen">
                    <Panel eventKey="1">
                        <Panel.Heading>
                            <Panel.Title toggle><Glyphicon glyph="plus" />{' '}Verklaring doorlopende werkervaring toevoegen</Panel.Title>
                        </Panel.Heading>
                        <Panel.Body collapsible>
                            <Form horizontal onSubmit={this.handleSubmit}>
                                <FormGroup controlId="WerkervaringToevoegenReferentie">
                                    <Col componentClass={ControlLabel} sm={4}>
                                        Verklaring toevoegen *
                                </Col>
                                    <Col sm={6}>
                                        <FormControl type="File" inputRef={input => this.fileInput = input} />
                                        {Api.showError(errors, "file")}
                                    </Col>
                                </FormGroup>
                                <FormGroup>
                                    <Col smOffset={8} sm={2}>
                                        <Button type="submit">Toevoegen</Button>
                                        {Api.showError(errors, "generalError")}
                                    </Col>
                                </FormGroup>
                            </Form>
                        </Panel.Body>
                    </Panel>
                </PanelGroup>
            </div>
        );
    }
}

export default VerklaringenToevoegen;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Leden/Lid/Werkervaring/VerklaringenToevoegen.js